const DEFAULT_CONTROLS_SETTINGS = {
    cc: Object.assign({}, {
        enable: true,
 		autoDisplay: true,
        langMenu: true
    }),
    loop: false,
    duration: true,
    fullscreen: true,
    play: true,
    progress: true,
    scrubbing: true,
    volume: true
}
export { DEFAULT_CONTROLS_SETTINGS }